import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Inicial from './inicial'; 
import About from './navigation/about'
import ProjetoBrand from './navigation/projetobrand';
import Gallery from './navigation/gallery';

const router = createBrowserRouter([
  {
    path: "/home",
    element: <Inicial />,
  },
  {
    path: "/about",
    element: <About />,
  },
   {
    path: "/brand",
    element: <ProjetoBrand />,
  },
   {
    path: "/gallery",
    element: <Gallery />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();